import "./App.css";
import { Routes, Route } from "react-router-dom";
import AlertMessage from "./components/AlertMessage/AlertMessage";
import Toasts from "./components/toast/Toasts";
import Home from "./pages/Home/Home";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import Login from "./pages/Login/Login";
import TableCheckboxSelect from "./components/Table/TableCheckboxSelect";
import { useDealsContext } from "./context/DealsProvider";
import TableCheckboxSelectUsed from "./components/Table/TableCheckboxSelectUsed";
import ViewAndEditModal from "./components/Modals/ViewAndEdit/ViewAndEditModal";
import { CONDITIONS } from "./utils/constants/SYSTEM";

function App() {
  const [{ dealHeaders, dealRows, condition }] = useDealsContext();
  
  return (
    <main className="App">
      <Routes>
        <Route 
          path="/"
          element={<ProtectedRoute><Home /></ProtectedRoute>}
        >
          <Route path="/new" element={<TableCheckboxSelect headers={dealHeaders} rows={dealRows} />} />
          <Route path="/new/:dealID/:dealType" element={(
            <ViewAndEditModal
              dealID={undefined} 
              dealCondition={CONDITIONS.NEW}
              dealType={undefined}
            />
          )} />

          <Route path="/in-stock" element={<TableCheckboxSelectUsed headers={dealHeaders} rows={dealRows} />} />
          <Route path="/in-stock/:dealID" element={(
            <ViewAndEditModal
              dealID={undefined}
              dealCondition={CONDITIONS.USED}
              dealType={undefined}
            />
          )} />
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
      <AlertMessage />
      <Toasts />
    </main>
  );
}

export default App;
